import type { FC } from "react"
import type { YAxisProps } from "recharts"
import { YAxis } from "recharts"

import type { TickProps } from "common/types/chart"
import { labelNumber } from "common/helpers/number"

const VotesYAxis: FC<YAxisProps> = ({ ...yAxisProps }) => (
  <YAxis
    axisLine={false}
    name="Votes"
    stroke="#EBF0F7"
    tick={<YTick dy={3} />}
    type="number"
    {...yAxisProps}
  />
)

export default VotesYAxis

const YTick: FC<TickProps> = ({
  x,
  y,
  payload,
  dy = 0,
  dx = 0,
  color = "#718096",
}) => (
  <g transform={`translate(${x as number},${y as number})`}>
    <text
      dx={dx}
      dy={dy}
      fill={color}
      fontSize="10px"
      textAnchor="end"
      x={0}
      y={0}
    >
      {labelNumber(Number(payload?.value))}
    </text>
  </g>
)
